module.exports = __webpack_public_path__ + "img/more-vertical.67e469de.svg";